import React, {
  ReactNode,
  forwardRef,
  ForwardedRef,
  useState,
  useEffect,
  ChangeEvent
} from 'react';
import cn from 'classnames';
import NextImage from 'src/shared-components/NextImage/NextImage';

const checkboxCheckedImage = 'shared/checkbox-checked-checkmark.svg';
const checkboxUncheckedImage = 'shared/checkbox-unchecked-checkmark.svg';
const checkboxDisabledImage = 'shared/checkbox-disabled-checkmark.svg';

export interface Props {
  titleClassName?: string;
  wrapperClassName?: string;
  checkboxWrapperClassName?: string;
  name?: string;
  title?: string | ReactNode;
  inputId: string;
  isChecked?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: boolean) => void;
  // TODO: replace any type with the actual type!
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const Checkbox = forwardRef(
  (props: Props, ref: ForwardedRef<HTMLInputElement> = null) => {
    const {
      name = '',
      title = '',
      inputId,
      titleClassName = '',
      wrapperClassName = '',
      checkboxWrapperClassName = '',
      isChecked = false,
      onChange = () => null,
      ...inputProps
    } = props;
    const [checked, setChecked] = useState<boolean>(isChecked);

    useEffect(() => {
      setChecked(isChecked);
    }, [isChecked]);

    const handlerClick = (event) => {
      setChecked(!checked);
      onChange(event, !checked);
    };
    const checkedIcon = checked ? checkboxCheckedImage : checkboxUncheckedImage;
    return (
      <>
        <input
          id={inputId}
          ref={ref}
          name={name}
          {...inputProps}
          checked={checked}
          onChange={handlerClick}
          className="hidden"
          type="checkbox"
        />
        <label
          htmlFor={inputId}
          className={cn('flex flex-row space-x-[11px]', wrapperClassName)}
        >
          <div className={cn('w-4 h-4', checkboxWrapperClassName)}>
            <NextImage
              alt="Справочник лекарств LIKIE"
              title="Справочник лекарств"
              src={inputProps.disabled ? checkboxDisabledImage : checkedIcon}
              layout="fixed"
              itemProp="logo"
              quality={100}
              width={18}
              height={18}
            />
          </div>
          <span className={cn('fs-caption-reg', titleClassName)}>{title}</span>
        </label>
      </>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
